var _style, _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "line_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Rectangle_20000",
    "data-name": "Rectangle 20000",
    style: {
      fill: "none"
    },
    d: "M0 0h24v22.868H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".line_svg__cls-2{fill:#4cc764}"))), /*#__PURE__*/React.createElement("g", {
    id: "line_svg__Group_21970",
    "data-name": "Group 21970",
    transform: "translate(-891 -202)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "line_svg__Rectangle_19997",
    "data-name": "Rectangle 19997",
    className: "line_svg__cls-2",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(891 202)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_svg__Group_21969",
    "data-name": "Group 21969",
    transform: "translate(899 211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_svg__Group_21968",
    "data-name": "Group 21968",
    style: {
      clipPath: "url(#line_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Path_17764",
    "data-name": "Path 17764",
    d: "M24 9.738C24 4.369 18.617 0 12 0S0 4.369 0 9.738c0 4.814 4.269 8.845 10.036 9.608.391.084.923.258 1.057.592a2.466 2.466 0 0 1 .039 1.085l-.171 1.027c-.052.3-.241 1.186 1.039.647a38.746 38.746 0 0 0 9.428-6.967A8.664 8.664 0 0 0 24 9.738",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Path_17765",
    "data-name": "Path 17765",
    className: "line_svg__cls-2",
    d: "M149.645 69.28a.229.229 0 0 0 .229-.229V68.2a.23.23 0 0 0-.229-.229h-2.291v-.884h2.291a.229.229 0 0 0 .229-.229v-.851a.23.23 0 0 0-.229-.229h-2.291v-.884h2.291a.229.229 0 0 0 .229-.229v-.851a.23.23 0 0 0-.229-.229h-3.371a.229.229 0 0 0-.229.229v5.228a.229.229 0 0 0 .229.229h3.371z",
    transform: "translate(-129.638 -56.442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Path_17766",
    "data-name": "Path 17766",
    className: "line_svg__cls-2",
    d: "M38.641 69.28a.229.229 0 0 0 .229-.229V68.2a.23.23 0 0 0-.229-.229h-2.292v-4.157a.23.23 0 0 0-.229-.229h-.851a.229.229 0 0 0-.229.229v5.233a.229.229 0 0 0 .229.229h3.371z",
    transform: "translate(-31.103 -56.442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Path_17767",
    "data-name": "Path 17767",
    className: "line_svg__cls-2",
    d: "M76.619 63.585h-.851a.229.229 0 0 0-.229.229v5.237a.229.229 0 0 0 .229.229h.851a.229.229 0 0 0 .229-.229v-5.237a.229.229 0 0 0-.229-.229",
    transform: "translate(-67.053 -56.442)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "line_svg__Path_17768",
    "data-name": "Path 17768",
    className: "line_svg__cls-2",
    d: "M99.223 63.585h-.851a.229.229 0 0 0-.229.229v3.111l-2.4-3.236a.219.219 0 0 0-.018-.024l-.014-.014-.012-.01h-.006l-.012-.008h-.007l-.013-.007h-.007l-.013-.006h-.932a.229.229 0 0 0-.229.229v5.237a.229.229 0 0 0 .229.229h.851a.229.229 0 0 0 .229-.229v-3.11l2.4 3.24a.233.233 0 0 0 .059.058l.014.009h.007l.011.005h.018l.016.005a.24.24 0 0 0 .06.008h.846a.229.229 0 0 0 .229-.229v-5.258a.229.229 0 0 0-.229-.229",
    transform: "translate(-83.863 -56.442)"
  }))))));
};

export default SvgLine;